import { Resource as s, API as a } from "@coveo/platform-client";
const e = class e extends s {
  get(t) {
    return this.api.get(this.buildPath(`${e.baseUrl}`, { trackingIds: t }));
  }
};
e.baseUrl = `/rest/organizations/${a.orgPlaceholder}/commerce/private/rule-count`;
let r = e;
export {
  r as RuleCount
};
//# sourceMappingURL=RuleCount.js.map
